import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  confetti: {
    pointerEvents: 'none',
    zIndex: '0 !important' as unknown as number,
  },
  dialogBody: {
    width: 500,

    [theme.fn.smallerThan('sm')]: {
      padding: theme.other.spacing._16,
      width: `calc(100vw - ${theme.other.spacing._16 * 2}px)`,
    },

    overflow: 'hidden',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._16,
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    textAlign: 'center',
  },
  eyebrow: {
    color: '#26837E',
    fontWeight: 800,
    textTransform: 'uppercase',
  },
  title: {
    textAlign: 'center',
  },
  description: {
    color: theme.colors.gray2[4],
    textAlign: 'center',
    maxWidth: 250,
  },

  ticketContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  viewport: {
    overflow: 'visible',
  },
  carouselContainer: {
    alignItems: 'center',
  },

  countdownContainer: {
    display: 'flex',
    justifyContent: 'center',
  },

  cta: {
    width: '100%',
  },

  loaderWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 240,
    width: '100%',
  },
}));
